<h1 mat-dialog-title>Order Created</h1>
<div mat-dialog-content>
    Order Submitted Successfully!
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</div>
